fragment MediaItem on MediaItem {
    id
    url
    name
    type
    folderId
    persistentKey
    info {
        contentLength
        contentType
        createdBy
        created
        modified
        tags {
            label
            type
            confidence
        }
    }
}
